// Shared bits for Social Lite panels (Creatomate modes + AI modes)
import { AlertTriangle, Download, Library, Loader2 } from "lucide-react";

export const pad = (n) => String(n).padStart(2, "0");
export const STATUS_COPY = { submitting: "Sending to Creatomate", planned: "Queued", waiting: "Queued", transcribing: "Rendering", rendering: "Rendering", succeeded: "Done", failed: "Failed" };

export function RenderResult({ job, testId = "social-lite-result" }) {
  const failed = job.status === "failed", done = job.status === "succeeded";
  return (
    <div className={`slt-result ${failed ? "is-failed" : ""}`} data-testid={testId}>
      <div className="slt-result-video">
        {done && (job.r2_url || job.url) ? <video src={job.r2_url || job.url} poster={job.snapshot_url || undefined} controls playsInline data-testid={`${testId}-video`} /> : (
          <div className="slt-result-wait">{failed ? <AlertTriangle size={22} /> : <Loader2 size={22} className="slt-spin" />}<span>{STATUS_COPY[job.status] || job.status}…</span></div>
        )}
      </div>
      <div className="slt-result-text">
        <strong data-testid={`${testId}-status`}>{failed ? "Render failed" : done ? `${job.label} ready` : `${job.label} — ${STATUS_COPY[job.status] || job.status}`}</strong>
        {failed && <small>{job.error || "Creatomate rejected the render."}</small>}
        {done && (job.in_library ? <span className="slt-lib"><Library size={12} /> In the Social Library</span> : job.library_pending ? <span className="slt-lib"><Loader2 size={12} className="slt-spin" /> Adding to the Social Library</span> : null)}
        {done && (job.r2_url || job.url) && <a className="slt-mini" href={job.r2_url || job.url} target="_blank" rel="noreferrer" data-testid={`${testId}-download`}><Download size={13} /> Download</a>}
      </div>
    </div>
  );
}
